// Compute a claim-pulse origin in canvas-relative units from a
// click event. Returns `{ x, y }` where both values are percentages
// of the AppStage canvas. Suitable for `cqw` / `cqh` positioning,
// which keeps the pulse aligned correctly under the canvas's
// dynamic scale + letterbox math.
//
// Why not viewport pixels: the canvas (.app-canvas) is letterboxed
// inside the viewport at a fixed 16:9 aspect with a user-controlled
// scale slider. A pulse positioned in raw viewport pixels would
// drift relative to the canvas content under any of those changes.
// Canvas-relative percentages stay locked to the cell wherever it
// renders.
//
// Falls back to viewport dimensions if .app-canvas isn't on the
// page (defensive. Shouldn't happen in practice but keeps the
// pulse positioning safe if the layout shape ever changes).
export function claimOriginFromEvent(e) {
  const rect = e.currentTarget.getBoundingClientRect();
  const cellCenterX = rect.left + rect.width / 2;
  const cellCenterY = rect.top + rect.height / 2;
  const canvas = document.querySelector('.app-canvas');
  const canvasRect = canvas?.getBoundingClientRect() || {
    left: 0,
    top: 0,
    width: window.innerWidth,
    height: window.innerHeight,
  };
  const x = ((cellCenterX - canvasRect.left) / canvasRect.width) * 100;
  const y = ((cellCenterY - canvasRect.top) / canvasRect.height) * 100;
  return { x, y };
}
